module.exports = __webpack_public_path__ + "img/team_ricarda.e9f28afc.png";